import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtual from '../../actions/mapa-veiculo/determinarPaginaAtualMapasVeiculos'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoMapasVeiculos extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtual}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualMapasVeiculos,
    total: state.mapasVeiculos.total,
    registrosPorPagina: state.registrosPorPaginaMapasVeiculos
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtual }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoMapasVeiculos)
